/**
 * Registration prefetch: decide if getUserByActivationId result means invalid/expired link.
 * @param {object|null|undefined} res - API result after axios success interceptor, or error marker from login.api
 * @returns {boolean}
 */
export function shouldShowInvalidActivationModal(res) {
  if (res === null || res === undefined) {
    return false;
  }
  if (res._activationFetchError) {
    return true;
  }
  if (res.code === 400) {
    return true;
  }
  if (res.data === null) {
    return true;
  }
  if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
    if (Object.values(res.data).some((v) => v === null)) {
      return true;
    }
  }
  if (res.email !== undefined || res.inviteStatus !== undefined) {
    return Object.values(res).some((v) => v === null);
  }
  if (Object.keys(res).length === 0) {
    return true;
  }
  return false;
}
